var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.contents)?_c('div',_vm._l((_vm.contents),function(item,i){return _c(_vm.getCmp(item.type),{key:i,tag:"component",attrs:{"config":item}},_vm._l((item.contents),function(sub,s){return _c(_vm.getCmp(sub.type),{key:'s' + s,tag:"component",attrs:{"config":sub}})}),1)}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }